import { BulkTaxReportComponent } from './bulk-tax-report.component';
export var bulktaxReportRoutes = [
    {
        path: 'bulktaxReport',
        component: BulkTaxReportComponent
    },
];
var BulkTaxReportRoutingModule = (function () {
    function BulkTaxReportRoutingModule() {
    }
    return BulkTaxReportRoutingModule;
}());
export { BulkTaxReportRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/bulk-tax-report/bulk-tax-report-routing.module.ts.pre-build-optimizer.js